import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import _ from 'lodash';
import './sample-request-card.css';

class SampleRequestCard extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBind(['onTestClick', 'buildRequestInputs']);
	}

	onTestClick() {
		this.props.onTest();
	}

	buildRequestInputs() {
		let fields = [
			<div className="param-header hbox vcenter" key={0}>
				<div className="label name">Parameter</div>
				<div className="label grow-1">Value</div>
			</div>
		];
		let rParams = Object.keys(this.props.requestParams);
		_.forEach(rParams, param => {
			if (param && param.length > 0) {
				let details = this.props.requestParams[param];
				let name = param.replace('mm-request-param-', '');
				fields.push(
					<div className="field-row hbox vcenter" key={param + 'request-field-row'}>
						<div className="name ellipse m-r-20" title={name + (details.required ? '*' : '') + (details.headerKey ? `[${details.headerKey}]` : '')}>
							{name + (details.required ? '*' : '') + (details.headerKey ? `[${details.headerKey}]` : '')}
						</div>
						{this.props.buildRequestFields(details, param)}
					</div>
				);
			}
		});
		if (fields.length <= 1) {
			return [];
		}
		return fields;
	}

	render() {
		let { className, validTest, async } = this.props;
		return (
			<div className={`sample-request-card shadow ${className ? className : ''}`}>
				<div className="hbox req-header">
					<h3 className="grow-1">Sample Request</h3>
				</div>
				<div className="desc-text">
					Press the Test button to generate a sample request and test your configuration before saving it. If you have defined parameters in the
					configuration you can assign values for them here.
				</div>
				{this.buildRequestInputs()}
				{this.props.content ? this.props.content : ''}
				<div className="btn-ctn">
					<div className="async-btn">
						<input type="checkbox" value={async} checked={async} onClick={this.props.toggleAsync} /> Async
					</div>
					<button className="btn secondary" disabled={!validTest} onClick={this.onTestClick}>
						Test
					</button>
				</div>
			</div>
		);
	}
}

export default SampleRequestCard;



// WEBPACK FOOTER //
// ./src/components/sample-request-card/SampleRequestCard.js